export default __webpack_public_path__ + "static/media/initGram.2caaddd5.png";